export default "__VITE_ASSET__D7dc6dgK__"